document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aa-testimonials').forEach((section) => {
    const track = section.querySelector('.aa-testimonials__track--scrollable');
    const dots = section.querySelectorAll('.aa-testimonials__dot');
    if (!track || !dots.length) return;

    const cards = Array.from(track.querySelectorAll('.aa-testimonial-card'));
    let currentIndex = 0;

    const scrollToIndex = (index) => {
      const card = cards[index];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => scrollToIndex(Number(dot.dataset.index)));
    });

    // Which card is "current" is derived from actual scroll position rather
    // than IntersectionObserver — with several cards visible at once, an
    // observer fires for all of them in a single batch on load, and picking
    // whichever entry happens to be processed last in that batch landed on
    // the wrong (rightmost) card instead of the first one.
    const updateActiveFromScroll = () => {
      let closestIndex = 0;
      let closestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      currentIndex = closestIndex;
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === closestIndex));
    };

    let scrollDebounce;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(updateActiveFromScroll, 100);
    });
    updateActiveFromScroll();

    // Auto-rotate — mirrors Dawn's own SlideshowComponent (assets/global.js:
    // autoplaySpeed, play/pause via setInterval/clearInterval, pause on
    // hover/focus, respects prefers-reduced-motion) so the Hero and
    // Testimonials sliders behave identically. Speed matches the Hero's
    // default change_slides_speed of 5s.
    const autoplaySpeed = 5000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let autoplay;

    const advance = () => {
      currentIndex = currentIndex >= cards.length - 1 ? 0 : currentIndex + 1;
      scrollToIndex(currentIndex);
    };

    const play = () => {
      clearInterval(autoplay);
      autoplay = setInterval(advance, autoplaySpeed);
    };

    const pause = () => clearInterval(autoplay);

    if (!reducedMotion.matches) {
      play();
      track.addEventListener('mouseover', pause);
      track.addEventListener('mouseleave', play);
      track.addEventListener('focusin', pause);
      track.addEventListener('focusout', play);
    }

    reducedMotion.addEventListener('change', () => {
      reducedMotion.matches ? pause() : play();
    });
  });
});
